export type PlatformOrgRow = {
  id: string;
  name: string;
  slug: string | null;
  org_type: string | null;
  is_active: boolean | null;
};

export type PlatformProfileRow = {
  id: string;
  email: string | null;
  full_name: string | null;
  display_name: string | null;
  email_domain: string | null;
  access_status: string | null;
  primary_organization_id: string | null;
  last_sign_in_at: string | null;
  created_at: string | null;
  blocked_reason?: string | null;
};

export type PlatformViewTab = "overview" | "orgs" | "users" | "costs" | "subscriptions";

export function nameForPlatformProfile(p: PlatformProfileRow): string {
  return p.full_name?.trim() || p.display_name?.trim() || p.email || p.id;
}
